import { render, staticRenderFns } from "./BrandView.vue?vue&type=template&id=058b2f00&"
import script from "./BrandView.vue?vue&type=script&lang=js&"
export * from "./BrandView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports